module.exports = __webpack_public_path__ + "img/도면_포항공장.03e41452.png";